// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"dcf6cd44","498":"82cf4ee4","511":"50c016f5","787":"2c030c48"}[chunkId] + ".chunk.js";
};